import request from '@/utils/request';

export function getAppletJumpShortChainDynamically(params) {
  return request({
    url: 'web-emall-wechat/promotionInfo/getAppletJumpShortChainDynamically',
    method: 'get',
    params,
  });
}
export function getJumpShortChain(data) {
  return request({
    url: 'web-emall-wechat/shortUrl/getJumpShortChain',
    method: 'post',
    data,
  });
}
export function getJumpShortChainTech(data) {
  return request({
    url: 'web-garage-tech/shortUrl/getJumpShortChain',
    method: 'post',
    data,
  });
}
